import React, { useState } from 'react';
import { SearchIcon, FilterIcon, DownloadIcon } from 'lucide-react';
export function AdminClienti() {
  const [searchTerm, setSearchTerm] = useState('');
  // Dati fittizi per la tabella
  const clienti = [{
    id: '1',
    ragioneSociale: 'Acme Srl',
    piva: '12345678901',
    abbonamentoAttivoDa: '15/01/2022',
    anniRinnovati: 1,
    creditiUtilizzati: 78,
    creditiDisponibili: 122,
    praticheGestite: 24,
    praticheAttive: 8,
    praticheSospese: 2,
    praticheLegali: 1,
    ultimoAccesso: '12/05/2023'
  }, {
    id: '2',
    ragioneSociale: 'TechSolutions Spa',
    piva: '98765432101',
    abbonamentoAttivoDa: '03/03/2022',
    anniRinnovati: 1,
    creditiUtilizzati: 156,
    creditiDisponibili: 44,
    praticheGestite: 42,
    praticheAttive: 12,
    praticheSospese: 0,
    praticheLegali: 3,
    ultimoAccesso: '18/05/2023'
  }, {
    id: '3',
    ragioneSociale: 'Industria Meccanica Srl',
    piva: '45678912301',
    abbonamentoAttivoDa: '22/05/2022',
    anniRinnovati: 1,
    creditiUtilizzati: 45,
    creditiDisponibili: 155,
    praticheGestite: 15,
    praticheAttive: 5,
    praticheSospese: 1,
    praticheLegali: 0,
    ultimoAccesso: '10/05/2023'
  }, {
    id: '4',
    ragioneSociale: 'Logistica Express Srl',
    piva: '78901234561',
    abbonamentoAttivoDa: '08/07/2022',
    anniRinnovati: 0,
    creditiUtilizzati: 32,
    creditiDisponibili: 68,
    praticheGestite: 10,
    praticheAttive: 4,
    praticheSospese: 0,
    praticheLegali: 0,
    ultimoAccesso: '05/05/2023'
  }, {
    id: '5',
    ragioneSociale: 'Alimentari Freschi Spa',
    piva: '56789012341',
    abbonamentoAttivoDa: '14/09/2022',
    anniRinnovati: 0,
    creditiUtilizzati: 98,
    creditiDisponibili: 102,
    praticheGestite: 30,
    praticheAttive: 10,
    praticheSospese: 3,
    praticheLegali: 2,
    ultimoAccesso: '15/05/2023'
  }, {
    id: '6',
    ragioneSociale: 'Edilizia Moderna Srl',
    piva: '23456789011',
    abbonamentoAttivoDa: '30/10/2021',
    anniRinnovati: 2,
    creditiUtilizzati: 210,
    creditiDisponibili: 90,
    praticheGestite: 65,
    praticheAttive: 15,
    praticheSospese: 5,
    praticheLegali: 4,
    ultimoAccesso: '17/05/2023'
  }, {
    id: '7',
    ragioneSociale: 'GreenEnergy Spa',
    piva: '89012345671',
    abbonamentoAttivoDa: '05/12/2021',
    anniRinnovati: 1,
    creditiUtilizzati: 145,
    creditiDisponibili: 55,
    praticheGestite: 48,
    praticheAttive: 12,
    praticheSospese: 2,
    praticheLegali: 1,
    ultimoAccesso: '16/05/2023'
  }, {
    id: '8',
    ragioneSociale: 'Retail Fashion Srl',
    piva: '34567890121',
    abbonamentoAttivoDa: '18/01/2023',
    anniRinnovati: 0,
    creditiUtilizzati: 25,
    creditiDisponibili: 175,
    praticheGestite: 8,
    praticheAttive: 3,
    praticheSospese: 1,
    praticheLegali: 0,
    ultimoAccesso: '08/05/2023'
  }];
  // Filtraggio per termine di ricerca
  const filteredClienti = clienti.filter(cliente => cliente.ragioneSociale.toLowerCase().includes(searchTerm.toLowerCase()) || cliente.piva.includes(searchTerm));
  return <div className="space-y-6 pb-16" data-id="element-1559">
      <div data-id="element-1560">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-1561">Clienti</h1>
        <p className="mt-1 text-sm text-gray-500" data-id="element-1562">
          Gestione dei clienti iscritti al servizio CashFirst
        </p>
      </div>
      <div className="bg-white shadow rounded-lg" data-id="element-1563">
        <div className="px-4 py-5 sm:p-6" data-id="element-1564">
          <div className="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4 sm:justify-between mb-4" data-id="element-1565">
            <div className="relative flex-1 max-w-md" data-id="element-1566">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-1567">
                <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-1568" />
              </div>
              <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-[#1A3E5C] focus:border-[#1A3E5C] sm:text-sm" placeholder="Cerca per ragione sociale, P.IVA..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-1569" />
            </div>
            <div className="flex space-x-2" data-id="element-1570">
              <button className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1A3E5C]" data-id="element-1571">
                <FilterIcon className="h-4 w-4 mr-2" data-id="element-1572" />
                Filtri
              </button>
              <button className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1A3E5C]" data-id="element-1573">
                <DownloadIcon className="h-4 w-4 mr-2" data-id="element-1574" />
                Esporta
              </button>
            </div>
          </div>
          <div className="overflow-x-auto" data-id="element-1575">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-1576">
              <thead className="bg-gray-50" data-id="element-1577">
                <tr data-id="element-1578">
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1579">
                    Ragione Sociale
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1580">
                    P.IVA
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1581">
                    Abbonamento da
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1582">
                    Anni Rinnovati
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1583">
                    Crediti
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1584">
                    Pratiche
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1585">
                    Ultimo Accesso
                  </th>
                  <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1586">
                    Azioni
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-1587">
                {filteredClienti.map(cliente => <tr key={cliente.id} className="hover:bg-gray-50" data-id="element-1588">
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1589">
                      <div className="text-sm font-medium text-gray-900" data-id="element-1590">
                        {cliente.ragioneSociale}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1591">
                      <div className="text-sm text-gray-500" data-id="element-1592">
                        {cliente.piva}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1593">
                      <div className="text-sm text-gray-500" data-id="element-1594">
                        {cliente.abbonamentoAttivoDa}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1595">
                      <div className="text-sm text-gray-500" data-id="element-1596">
                        {cliente.anniRinnovati}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1597">
                      <div className="text-sm text-gray-500" data-id="element-1598">
                        <span className="font-medium text-green-600" data-id="element-1599">
                          {cliente.creditiDisponibili}
                        </span>{' '}
                        /{' '}
                        <span className="text-gray-500" data-id="element-1600">
                          {cliente.creditiUtilizzati + cliente.creditiDisponibili}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1601">
                      <div className="text-sm text-gray-500" data-id="element-1602">
                        <span className="font-medium" data-id="element-1603">
                          {cliente.praticheAttive}
                        </span>{' '}
                        attive,{' '}
                        <span className="text-amber-600" data-id="element-1604">
                          {cliente.praticheSospese}
                        </span>{' '}
                        sospese,{' '}
                        <span className="text-red-600" data-id="element-1605">
                          {cliente.praticheLegali}
                        </span>{' '}
                        legali
                        <div className="text-xs text-gray-400" data-id="element-1606">
                          {cliente.praticheGestite} totali
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1607">
                      <div className="text-sm text-gray-500" data-id="element-1608">
                        {cliente.ultimoAccesso}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-1609">
                      <a href="#" className="text-[#1A3E5C] hover:text-[#15324a]" data-id="element-1610">
                        Dettagli
                      </a>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          <div className="mt-4 flex items-center justify-between" data-id="element-1611">
            <div data-id="element-1612">
              <p className="text-sm text-gray-700" data-id="element-1613">
                Visualizzazione{' '}
                <span className="font-medium" data-id="element-1614">{filteredClienti.length}</span> di{' '}
                <span className="font-medium" data-id="element-1615">{clienti.length}</span> clienti
              </p>
            </div>
            <div data-id="element-1616">
              <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination" data-id="element-1617">
                <a href="#" className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-1618">
                  <span className="sr-only" data-id="element-1619">Precedente</span>
                  <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-id="element-1620">
                    <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-1621" />
                  </svg>
                </a>
                <a href="#" className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-1622">
                  1
                </a>
                <a href="#" className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-1623">
                  <span className="sr-only" data-id="element-1624">Successivo</span>
                  <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-id="element-1625">
                    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" data-id="element-1626" />
                  </svg>
                </a>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>;
}